export default "__VITE_ASSET__DZdjjRxL__"